import { LookupKeys } from '../../../models/crm/lookup.model';
import { LookupBase } from '../../../models/utils/lookup-base.model';

export const OVERRIDE_BASIS_VALUES = ['LIFE', 'LIFE + TARGET', 'TARGET', 'PREMIUM', 'ANNUITY'] as const;

export type OverrideBasis = (typeof OVERRIDE_BASIS_VALUES)[number];

export const OVERRIDE_BASIS_LOOKUP: LookupBase[] = OVERRIDE_BASIS_VALUES.map(value => {
  return { [LookupKeys.value]: value, [LookupKeys.description]: value };
});
